
/**
 * @Description //TODO 全局校验
 * @type {{chinese_char: RegExp, letter_26: RegExp, num_small_n: RegExp, special_char: RegExp, num_gte_0: RegExp, num: RegExp, num_small_m_n: RegExp, id_card: RegExp, num_lte_0: RegExp, integer: RegExp, float_gte_0: RegExp, float: RegExp, num_letter_underline: RegExp, num_least_n: RegExp, num_gt_0: RegExp, password: RegExp, num_is_n: RegExp, letter_26_up: RegExp, num_letter_26: RegExp, float_lte_0: RegExp, float_lt_0: RegExp, email: RegExp, letter_26_low: RegExp, num_m_n: RegExp, special_zh_char: undefined, photo: RegExp, str_n: RegExp, url: RegExp, phone: RegExp, num_lt_0: RegExp, float_gt_0: RegExp}}
 * @author Zhangbin
 * @date 2021/4/30 16:23
 * @Ver 1.3.1
 * @extends Vue
 */

export const validFormat = {
  num: (/^[0-9]*$/),                              // 验证数字
  num_gt_0: (/^\+?[1-9][0-9]*$/),                 // 验证非零的正整数
  num_lt_0: (/^\-[1-9][0-9]*$/),                  // 验证非零的负整数
  num_gte_0: (/^\d+$/),                           // 验证非负整数（正整数 + 0）
  num_lte_0: (/^((-\d+)|(0+))$/),                 // 验证非正整数（负整数 + 0）

  integer: (/^-?\d+$/),                           // 整数
  float_gte_0: (/^\d+(\.\d+)?$/),                  // 非负浮点数（正浮点数 + 0）
  float_gt_0: (/^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/),// 正浮点数
  float_lte_0: (/^((-\d+(\.\d+)?)|(0+(\.0+)?))$/),                  // 非正浮点数（负浮点数 + 0）
  float_lt_0: (/^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/),// 负浮点数
  float: (/^(-?\d+)(\.\d+)?$/),                      // 浮点数

  letter_26: (/^[A-Za-z]+$/),                     // 验证由26个英文字母组成的字符串
  letter_26_up: (/^[A-Z]+$/),                     // 验证由26个大写英文字母组成的字符串
  letter_26_low: (/^[a-z]+$/),                    // 验证由26个小写英文字母组成的字符串
  num_letter_26: (/^[A-Za-z0-9]+$/),              // 验证由数字和26个英文字母组成的字符串
  num_letter_underline: (/^\w+$/),                // 验证由数字、26个英文字母或者下划线组成的字符串
  chinese_char: (/^[\u4e00-\u9fa5],{0,}$/),       // 验证汉字
  id_card:  (/(^\d{15}$)|(^\d{17}(\d|X|x)$)/),    // 验证身份证号（15位或18位数字）
  photo: (/.jpg$|.jpeg$|.gif$|.png$/i),           // 图片格式

  ip: (/^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/),			// 验证IP
  //ip: (/^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/),			// 验证IP
  email: (/^[0-9a-z][0-9a-z\-\_\.]+@([0-9a-z][0-9a-z\-]*\.)+[a-z]{2,}$/i),              // 验证Email地址
  url: (/^https:\/\/([0-9a-z][0-9a-z\-]*\.)+[a-z]{2,}(:\d+)?\/[0-9a-z%\-_\/\.]+/i),      // 验证InternetURL
  // urlRegExp: (/^(?:http|https):\/\/(?:[^/@]+@)?(?:www\.)?([^/:@]+)(?::\d+)?(?:[^#]*\/[^?#]*)?$/), // 验证InternetURL
  urlRegExp: (/^(http|https|ftp)\:\/\/([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&%\$\-]+)*@)?((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.[a-zA-Z]{2,4})(\:[0-9]+)?(\/[^\/][a-zA-Z0-9\.\,\?\'\\/\+&%\$#\=~_\-@\u4e00-\u9fa5]*)*$/), // 验证InternetURL
  
  phone: (/^1[0-9]{10}$/),                                 // 验证手机号码
  strictpassword: (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,18}$/),                        // 至少8-16个字符，至少1个大写字母，1个小写字母和1个数字，其他可以是任意字符
  password: (/^([a-zA-Z\d\`\~\!\@\#\$\%\^\&\*\(\)\-\_\+\=\[\{\]\}\\\|\;\:\'\"\<\,\>\.\/\?]){6,18}$/),
  username_xm: (/^[\u4e00-\u9fa5\w\.\-\_]+$/),												// 验证汉字、下划线、字母、数字

  special_zh_char:  (/[·！￥……（）——《》？：“”【】、；‘’，。、｛｝]/im),                      // 中文特殊字符
  special_char: (/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+=｛｝|《》？：“”【】、；‘’，。、]/im), //所有特殊字符
	
	hex: ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','a','b','c','d','e','f']
}

export function checkHexChar(value){
    for(let i=0;i<value.length;i++){
        if(validFormat.hex.indexOf(value.charAt(i)) == -1){
            return false;
        }
    }
    return true;
}

// 校验信息：符合对应的格式，返回true，否则返回false
export function checkFormat (value, format) {
  if(format == null){
    return false;
  }
  if(format.test(value)){
    return true;
  }else{
    return false;
  }
}

// 判断变量是否空值undefined, null, '', false, NaN, [], {} 均返回true，否则返回false
export function checkEmpty (value){
  switch (typeof value) {
    case "undefined":
      return true
      break
    case "string":
      value = value.replace(/\s+/g,"")
      if(value.length === 0){
        return true
      }
      break
    case "boolean":
      if(!value){
        return true
      }
      break
    case "number":
      if(isNaN(value)){
        return true
      }
      break
    case "object":
      if(null === value){
        return true
      }
      if(undefined != value.length && value.length == 0){
        return true
      }
      for(let k in value){
        return false
      }
      return true
      break
  }
  return false;
}

/***
 * TODO 检索登录设备,判断是否与参数设备类型一致
 * @param {String} targetDevice
 * @return 传入参数时判断当前设备是否是该设备类型;不传参数时,返回设备类型
 */
export function checkLoginDevice(targetDevice) {

	var ua = navigator.userAgent,
	isWindowsPhone = /(?:Windows Phone)/.test(ua),
	isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
	isAndroid = /(?:Android)/.test(ua),
	isFireFox = /(?:Firefox)/.test(ua),
	isChrome = /(?:Chrome|CriOS)/.test(ua),
	isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
	isPhone = /(?:iPhone)/.test(ua) && !isTablet,
	isPc = !isPhone && !isAndroid && !isSymbian && !isTablet;

	if (checkEmpty(targetDevice)) {
		if (isPhone || isAndroid) {
			return 'phone';
		} else if (isTablet) {
			return 'pad';
		} else if(isPc){
			return 'pc';
		}
	} else {
		if (targetDevice.toLowerCase() == 'pc') {
			return isPc;
		} else if (targetDevice.toLowerCase() == 'pad') {
			return isTablet;
		} else if (targetDevice.toLowerCase() == 'phone') {
			return (isPhone || isAndroid);
		}
	}

};



// WEBPACK FOOTER //
// ./src/global/global-valid.js